import $ from 'jquery';
import LocalStorage from '../local_data';
import Authenticate from './Authenticate';

let ajaxRequest = {};

class Fetch {

    constructor() {
        let that = this;

        this.defaults = {
            authenticate: false,
            client_id: null,
            endPoint: '',
            data: {},
            method: 'GET',
            headers: null,
            publicAuth: true,
            canUsePublicAuth: true,
            removedUserAuth: false,
            dataType: 'json',
            multiCall: true,
            multiCallKey: '',
            onBeforeSend: null,
            onSuccess: null,
            onError: null,
            onAuthenticateError: function (jqXHR, textStatus, errorThrown) {
                
                if (that.defaults.publicAuth) {
                    
                    if(!window.ajaxAuthRequestLoading) {
                        window.ajaxAuthRequest = null;
                    }
                    
                    //if public Auth, then there's no refesh token - so, remove access token data and resend request
                    let publicAuth = new LocalStorage.PublicAuth(that.defaults.client_id);
                    publicAuth.removeData();
                    
                    //resend request
                    that.send(that.defaults);
                } else {
                     //if user Auth, then there's a refesh token - so, refresh token. then, resend request
                    let userDetails = new LocalStorage.UserDetails(that.defaults.client_id);
                    
                    new Authenticate().refreshUserAccessToken(that.defaults.client_id, userDetails.getData().data.refresh_token)
                    .then((data) => {
                        window.ajaxAuthRequest = null;
                        if(data) {
                            that.defaults.removedUserAuth = false;
                        } else {
                            userDetails.removeData();
                            that.defaults.removedUserAuth = true;
                        }
                        
                        //resend request
                        that.send(that.defaults);
                    }).catch(error => {
                        if (error.textStatus.status === 401) {
                              let eventCall = new CustomEvent("oms_userLogout", {
                                detail: {
                                    client_id: that.defaults.client_id
                                }
                            });
                            that.defaults.removedUserAuth = true;
                            document.dispatchEvent(eventCall);
                        }
                    });
                }
            },
            onLogout: null,
        };
    }

    /**
     * Ajax Request
     * 
     * @param {*} config 
     */
    fetch(config) {
        //by default multi call is enabled without aborting
        //in case of multicall key is provided, then it allows to abort reuest from same key
        let abortEnable = (config.multiCallKey) ? true : false;

        let key = config.multiCallKey || config.endPoint;

        if ((abortEnable) && (ajaxRequest[key] != null)) {
            ajaxRequest[key].abort();
            ajaxRequest[key] = null;
        }

        ajaxRequest[key] = $.ajax({
            url: config.endPoint,
            data: config.data,
            dataType: config.dataType,
            method: config.method,
            cache: true,
            headers: config.headers,
            contentType: config.contentType,
            processData: config.processData,
            beforeSend: (jqXHR, settings) => {
                if (typeof config.onBeforeSend === "function") {
                    config.onBeforeSend.call({source: "ajaxBeforeSend"}, jqXHR, settings);
                }
            },
        }).done((data, status) => {
            let responseData = {
                data: data,
                authType: config.publicAuth ? "public" : "user",
                logout: config.removedUserAuth,
                client_id: config.client_id,
            };
            if (typeof config.onSuccess === "function") {
                config.onSuccess.call({source: "ajaxDone"}, responseData, status);
            }
        }).fail((jqXHR, textStatus, errorThrown) => {
            if (jqXHR.status === 401 && config.canUsePublicAuth) {
                if (typeof config.onAuthenticateError === "function") {
                    config.onAuthenticateError.call({source: "ajaxFail"}, errorThrown, jqXHR, textStatus);
                }
            } else {
                if (typeof config.onError === "function") {
                    config.onError.call({source: "ajaxFail"}, errorThrown, jqXHR, textStatus);
                }
            }
        });

    }

}

export default Fetch;